<div class="row">
	<div class="col-12" *ngIf="opciones.tipoMoneda !== 'CLP' && !(opciones.valorTipoMoneda > 0)">
		<div class="alert alert-warning" role="status">Falta el valor de {{ opciones.tipoMoneda === 'OTHER' ? 'la moneda' : opciones.tipoMoneda }}. Configure la cotización en Moneda para calcular los importes en CLP y emitir.</div>
	</div>
	<!-- Especificaciones del documento: se muestran antes del resumen de totales -->
	<div class="col-xl-4 col-md-6 col-xs-12 mt-sm-4 mt-md-0">
		<div class="card-custom card">
			<div class="card-content">
				<div class="card-header">
					<h5 class="mb-0">Especificaciones</h5>
				</div>
				<div class="card-body" [formGroup]="totalesDteFormGroup" (blur)="onSubmit()">
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Formato</div>
						<div class="col-7">
							<ng-select [items]="sizeFormat" bindLabel="name" formControlName="formato" [clearable]="false" (blur)="onSubmit()" [attr.disabled]="true" [readonly]="true" [ngClass]="{ 'hide-arrow': true }" placement="right"></ng-select>
							<div *ngIf="(totalesDteFormGroup.touched && totalesDteFormGroup.controls.formato.invalid) || totalesDteFormGroup.controls.tipoDte.invalid" class="text-danger">
								<div *ngIf="totalesDteFormGroup.controls.formato.errors?.required">Campo Requerido</div>
							</div>
						</div>
					</div>
					<div class="form-group row mx-auto" *ngIf="!(currentInvoiceType == 3)">
						<div class="col-5 label-control">Documento</div>
						<div class="col-7">
							<ng-select [items]="tipoDteSource" bindLabel="nombre" formControlName="tipoDte" [clearable]="false" (blur)="onSubmit()" [attr.disabled]="true" [readonly]="true" [ngClass]="{ 'hide-arrow': true }" placement="right" ngbTooltip="{{ totalesDteFormGroup.controls.tipoDte.value.nombre }}">
                                <ng-template ng-label-tmp let-item="item">{{ ShowInSettlement ? 'Liquidación' : item.nombre }}</ng-template>
                            </ng-select>
							<div *ngIf="(totalesDteFormGroup.touched && totalesDteFormGroup.controls.tipoDte.invalid) || totalesDteFormGroup.controls.tipoDte.invalid" class="text-danger">
								<div *ngIf="totalesDteFormGroup.controls.tipoDte.errors?.required">Campo Requerido</div>
							</div>
						</div>
					</div>
					<div class="form-group row mx-auto" *ngIf="showTransferType">
						<div class="col-5 label-control">Tipo Traslados</div>
						<div class="col-7">
							<ng-select [items]="tipoTrasladosSource" bindLabel="nombre" formControlName="tipoTraslado" [clearable]="false" (blur)="onSubmit()">
								<ng-template ng-option-tmp let-item="item">
									<div title="{{ item.nombre }}" ngbTooltip="{{ item.nombre }}" container="body" placement="right">{{ item.nombre }}</div>
								</ng-template>
							</ng-select>
						</div>
					</div>
					<div class="form-group row mx-auto" *ngIf="showDeliveryType">
						<div class="col-5 label-control">Tipo Despacho</div>
						<div class="col-7">
							<ng-select [items]="tipoDespachoSource" bindLabel="nombre" formControlName="tipoDespacho" [clearable]="false" (blur)="onSubmit()">
								<ng-template ng-option-tmp let-item="item">
									<div ngbTooltip="{{ item.nombre }}" container="body" placement="right">{{ item.nombre }}</div>
								</ng-template>
							</ng-select>
						</div>
					</div>
					<div class="form-group row mx-auto" *ngIf="showPaymentType">
						<div class="col-5 label-control">Forma de Pago</div>
						<div class="col-7">
							<ng-select [items]="formasPagoSource" bindLabel="nombreForma" formControlName="formaPago" [clearable]="false" (change)="updateFormaPago($event)" (blur)="onSubmit()"></ng-select>
						</div>
					</div>
					<div class="form-group row mx-auto" *ngIf="!showInExport && currentInvoiceType == 1">
						<div class="col-5 label-control">Medio de Pago</div>
						<div class="col-7">
							<ng-select placeholder="Seleccione un medio de pago" [items]="medioPagoSource" bindLabel="nombreMedio" formControlName="medioPagoBoleta" [clearable]="true" clearAllText="Limpiar" (blur)="onSubmit()"> </ng-select>
						</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Fecha de Emisión</div>
						<div class="col-7">
							<input #fechaEmisionInput type="text" [maxDate]="rangoEmision.max" [minDate]="rangoEmision.min" ngxDaterangepickerMd name="fechaEmision" formControlName="fechaEmision" class="form-control" [locale]="locale" [singleDatePicker]="true" [autoApply]="true" (focus)="actualizarRangoFechaEmision()" (input)="detectChangeResumenDate($event)" (change)="detectChangeResumenDate($event)" />
							<div *ngIf="totalesDteFormGroup.controls.fechaEmision.touched && totalesDteFormGroup.controls.fechaEmision.invalid" class="text-danger">
								<div *ngIf="totalesDteFormGroup.controls.fechaEmision.errors?.required">Ingrese la fecha de emisión.</div>
								<div *ngIf="totalesDteFormGroup.controls.fechaEmision.errors?.fechaInvalida">Fecha inválida, usar formato dd/mm/yyyy</div>
								<div *ngIf="totalesDteFormGroup.controls.fechaEmision.errors?.fechaFueraDeRango">La fecha debe estar entre {{ rangoEmision.min.format('DD/MM/YYYY') }} y {{ rangoEmision.max.format('DD/MM/YYYY') }}.</div>
							</div>
						</div>
					</div>
					<div class="form-group row mx-auto" *ngIf="showDueDate && !showInExport">
						<div class="col-5 label-control">Dias de Vencimiento</div>
						<div class="col-7">
							<input type="text" class="form-control" formControlName="diasVencimiento" (blur)="onSubmit()" />
							<div *ngIf="totalesDteFormGroup.touched && totalesDteFormGroup.controls.diasVencimiento.invalid" class="text-danger">
								<div *ngIf="totalesDteFormGroup.controls.diasVencimiento.errors?.PositiveNumber">Número debe ser positivo</div>
							</div>
						</div>
					</div>
					<div class="form-group row mx-auto" *ngIf="showDiscount && !showInExport">
						<div class="col-5 label-control">Descuento Global (Monto)</div>
						<div class="col-7">
							<input type="text" class="form-control" formControlName="descuentoGlobal" (blur)="calculateTotals()" />
							<div *ngIf="totalesDteFormGroup.touched && totalesDteFormGroup.controls.descuentoGlobal.invalid" class="text-danger">
								<div *ngIf="totalesDteFormGroup.controls.descuentoGlobal.errors?.NonNegativeNumber">Número no debe ser negativo</div>
							</div>
							<small>Se aplica sobre el neto total</small>
						</div>
						<div class="col-5 label-control" *ngIf="opciones.tipoMoneda != 'CLP' && !showInExport">Descuento Global CLP</div>
						<div class="col-7 text-right mt-4" *ngIf="opciones.tipoMoneda != 'CLP' && currentInvoiceType != 4">
							{{ montoDescuento | number : "1.0-0" : "es" }}
						</div>
						<div class="col-7 text-right mt-4" *ngIf="opciones.tipoMoneda != 'CLP' && currentInvoiceType == 4">
							{{ montoDescuentoForeign | number : "1.0-0" : "es" }}
						</div>
					</div>
					<!-- CredEC e IVA Terceros: ver ng-template #credECTemplate / #ivaTercerosTemplate, proyectados desde app-opciones-adicionales-dte -->
					<div *ngIf="showInExport">
						<div class="form-group row mx-auto">
							<div class="col-5 label-control">Forma Pago Exp</div>
							<div class="col-7">
								<ng-select formControlName="formaPagoExportacion" [items]="formasPagoExportacionSource" [clearable]="false" (blur)="onSubmit()" bindLabel="descripcion"> </ng-select>
							</div>
						</div>
						<div class="form-group row mx-auto">
							<div class="col-5 label-control">Modalidad de Venta</div>
							<div class="col-7">
								<ng-select formControlName="modalidadVenta" [items]="modalidadVentaSource" [clearable]="false" (blur)="onSubmit()" bindLabel="sigla"> </ng-select>
							</div>
						</div>
						<div class="form-group row mx-auto">
							<div class="col-5 label-control">Clausula de Venta</div>
							<div class="col-7">
								<ng-select formControlName="clausulaVenta" [items]="clausulaVentaSource" [clearable]="false" (blur)="onSubmit()" bindLabel="sigla"> </ng-select>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="col-xl-4 col-md-6 col-xs-12" *ngIf="ShowInSettlement">
		<div class="card card-custom">
			<div class="card-content">
				<div class="card-header d-flex justify-content-between align-items-center">
					<h5 class="mb-0">{{ vistaResumenLiquidacion === "DOCUMENTOS" ? "Resumen" : "Resumen comisiones" }}</h5>
					<div class="toggle-switch toggle-switch--sm">
						<button type="button" class="toggle-btn" [class.active]="vistaResumenLiquidacion === 'DOCUMENTOS'" (click)="seleccionarVistaResumenLiquidacion('DOCUMENTOS')">Resumen</button>
						<button type="button" class="toggle-btn" [class.active]="vistaResumenLiquidacion === 'COMISIONES'" (click)="seleccionarVistaResumenLiquidacion('COMISIONES')">Comisiones</button>
					</div>
				</div>
				<div class="card-body" *ngIf="vistaResumenLiquidacion === 'DOCUMENTOS'">
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Neto</div>
						<div class="col-7 text-right">{{ netoAfectoResumen | number : "1.0-0" : "es" }}</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Exento</div>
						<div class="col-7 text-right">{{ exentoResumen | number : "1.0-0" : "es" }}</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Subtotal</div>
						<div class="col-7 text-right">{{ subTotalResumen | number : "1.0-0" : "es" }}</div>
					</div>
					<div class="form-group row mx-auto" *ngIf="subTotalExento > 0">
						<div class="col-5 label-control">Subtotal Exento</div>
						<div class="col-7 text-right">{{ subTotalExento | number : "1.0-0" : "es" }}</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">IVA</div>
						<div class="col-7 text-right">{{ montoIva | number : "1.0-0" : "es" }}</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Imp. específicos</div>
						<div class="col-7 text-right">{{ montoTotalImpuestosEspecificos | number : "1.0-0" : "es" }}</div>
					</div>
					<div class="form-group row mx-auto text-danger" *ngIf="showCredEC && totalesDteEmitido?.aplicaCredEC">
						<div class="col-5 label-control">CredEC</div>
						<div class="col-7 text-right">-{{ totalesDteEmitido?.credEC | number : '1.0-0' : 'es' }}</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Total</div>
						<div class="col-7 text-right">{{ totalResumen | number : "1.0-0" : "es" }}</div>
					</div>
				</div>
				<div class="card-body" *ngIf="vistaResumenLiquidacion === 'COMISIONES'">
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Neto</div>
						<div class="col-7 text-right">
							{{ netoAfectoResumenComision | number : "1.0-0" : "es" }}
						</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Subtotal</div>
						<div class="col-7 text-right">
							{{ subTotalResumenComision | number : "1.0-0" : "es" }}
						</div>
						<!--<div *ngIf="subTotalResumen < 0 " class="text-danger">Monto no puede ser negativo</div>-->
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Exento</div>
						<div class="col-7 text-right">
							{{ exentoResumenComision | number : "1.0-0" : "es" }}
						</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">IVA</div>
						<div class="col-7 text-right">
							{{ montoIvaComision | number : "1.0-0" : "es" }}
						</div>
					</div>

					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Total</div>
						<div class="col-7 text-right">
							{{ totalResumenComision | number : "1.0-0" : "es" }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="col-xl-4 col-md-6 col-xs-12 mt-sm-4 mt-md-0" *ngIf="!ShowInSettlement && currentInvoiceType != 4 && currentInvoiceType != 2 && (vistaResumen === 'CLP' || opciones.tipoMoneda === 'CLP')">
		<!-- general purpouse resumme -->
		<div class="card card-custom">
			<div class="card-content">
				<div class="card-header d-flex justify-content-between align-items-center">
					<h5 class="mb-0">Resumen</h5>
					<div class="toggle-switch toggle-switch--sm" *ngIf="opciones.tipoMoneda != 'CLP'">
						<button type="button" class="toggle-btn" [class.active]="vistaResumen === 'CLP'" (click)="seleccionarVistaResumen('CLP')">CLP</button>
						<button type="button" class="toggle-btn" [class.active]="vistaResumen === 'EXTRANJERA'" (click)="seleccionarVistaResumen('EXTRANJERA')">{{ opciones.tipoMoneda === "OTHER" ? "Otra Moneda" : opciones.tipoMoneda }}</button>
					</div>
				</div>
				<div class="card-body">
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Neto</div>
						<div class="col-7 text-right">
							{{ netoAfectoResumen | number : "1.0-0" : "es" }}
						</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Exento</div>
						<div class="col-7 text-right">
							{{ exentoResumen | number : "1.0-0" : "es" }}
						</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Subtotal</div>
						<div class="col-7 text-right">
							{{ subTotalResumen | number : "1.0-0" : "es" }}
						</div>
						<div *ngIf="subTotalResumen < 0 && !ShowInSettlement" class="text-danger">Monto no puede ser negativo</div>
					</div>
					<div class="form-group row mx-auto" *ngIf="subTotalExento > 0">
						<div class="col-5 label-control">Subtotal Exento</div>
						<div class="col-7 text-right">
							{{ subTotalExento | number : "1.0-0" : "es" }}
						</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">IVA</div>
						<div class="col-7 text-right">
							{{ montoIva | number : "1.0-0" : "es" }}
						</div>
					</div>
					<div class="form-group row mx-auto text-danger" *ngIf="currentInvoiceType == 3">
						<div class="col-5 label-control">Retención IVA</div>
						<div class="col-7 text-right">
							{{ montoRetencionIva | number : "1.0-0" : "es" }}
						</div>
					</div>
					<div *ngIf="currentInvoiceType != 1" class="form-group row mx-auto">
						<div class="col-5 label-control">Imp. específicos</div>
						<div class="col-7 text-right">
							{{ montoTotalImpuestosEspecificos | number : "1.0-0" : "es" }}
						</div>
					</div>
					<div class="form-group row mx-auto" *ngIf="showComission">
						<div class="col-5 label-control">Comision / Cargos</div>
						<div class="col-7 text-right">
							{{ totalResumenComision | number : "1.0-0" : "es" }}
						</div>
					</div>
					<div class="form-group row mx-auto" *ngIf="showComission">
						<div class="col-5 label-control">IVA Com. / Cargos</div>
						<div class="col-7 text-right">
							{{ montoIvaComision | number : "1.0-0" : "es" }}
						</div>
					</div>
					<div class="form-group row mx-auto text-danger" *ngIf="showCredEC && totalesDteEmitido?.aplicaCredEC">
						<div class="col-5 label-control">
							CredEC
						</div>
						<div class="col-7 text-right">
							-{{ totalesDteEmitido?.credEC | number : '1.0-0' : 'es' }}
						</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Total</div>
						<div class="col-7 text-right">
							{{ totalResumen | number : "1.0-0" : "es" }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="col-xl-4 col-md-6 col-xs-12 mt-sm-4 mt-md-0" *ngIf="currentInvoiceType == 2 && totalesDteFormGroup.controls.tipoTraslado.value.id != 6 && (vistaResumen === 'CLP' || opciones.tipoMoneda === 'CLP')">
		<!-- general purpouse resumme -->
		<div class="card card-custom">
			<div class="card-content">
				<div class="card-header d-flex justify-content-between align-items-center">
					<h5 class="mb-0">Resumen</h5>
					<div class="toggle-switch toggle-switch--sm" *ngIf="opciones.tipoMoneda != 'CLP'">
						<button type="button" class="toggle-btn" [class.active]="vistaResumen === 'CLP'" (click)="seleccionarVistaResumen('CLP')">CLP</button>
						<button type="button" class="toggle-btn" [class.active]="vistaResumen === 'EXTRANJERA'" (click)="seleccionarVistaResumen('EXTRANJERA')">{{ opciones.tipoMoneda === "OTHER" ? "Otra Moneda" : opciones.tipoMoneda }}</button>
					</div>
				</div>
				<div class="card-body">
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Neto</div>
						<div class="col-7 text-right">
							{{ netoAfectoResumen | number : "1.0-0" : "es" }}
						</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Exento</div>
						<div class="col-7 text-right">
							{{ exentoResumen | number : "1.0-0" : "es" }}
						</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Subtotal</div>
						<div class="col-7 text-right">
							{{ subTotalResumen | number : "1.0-0" : "es" }}
						</div>
						<div *ngIf="subTotalResumen < 0" class="text-danger">Monto no puede ser negativo</div>
					</div>

					<div class="form-group row mx-auto">
						<div class="col-5 label-control">IVA</div>
						<div class="col-7 text-right">
							{{ montoIva | number : "1.0-0" : "es" }}
						</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Imp. específicos</div>
						<div class="col-7 text-right">
							{{ montoTotalImpuestosEspecificos | number : "1.0-0" : "es" }}
						</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Total</div>
						<div class="col-7 text-right">
							{{ totalResumen | number : "1.0-0" : "es" }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="col-xl-4 col-md-6 col-xs-12 mt-sm-4 mt-md-0" *ngIf="currentInvoiceType == 2 && totalesDteFormGroup.controls.tipoTraslado.value.id == 6 && (vistaResumen === 'CLP' || opciones.tipoMoneda === 'CLP')">
		<!-- general purpouse resumme -->
		<div class="card card-custom">
			<div class="card-content">
				<div class="card-header d-flex justify-content-between align-items-center">
					<h5 class="mb-0">Resumen</h5>
					<div class="toggle-switch toggle-switch--sm" *ngIf="opciones.tipoMoneda != 'CLP'">
						<button type="button" class="toggle-btn" [class.active]="vistaResumen === 'CLP'" (click)="seleccionarVistaResumen('CLP')">CLP</button>
						<button type="button" class="toggle-btn" [class.active]="vistaResumen === 'EXTRANJERA'" (click)="seleccionarVistaResumen('EXTRANJERA')">{{ opciones.tipoMoneda === "OTHER" ? "Otra Moneda" : opciones.tipoMoneda }}</button>
					</div>
				</div>
				<div class="card-body">
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Neto</div>
						<div class="col-7 text-right">0</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Subtotal</div>
						<div class="col-7 text-right">0</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Exento</div>
						<div class="col-7 text-right">0</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">IVA</div>
						<div class="col-7 text-right">0</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Imp. específicos</div>
						<div class="col-7 text-right">0</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Total</div>
						<div class="col-7 text-right">0</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-7 text-right" style="color: red">Sin Valor Comercial</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- RESUMEN PARA DTE EXPORTACION -->
	<div class="col-xl-4 col-md-6 col-xs-12 mt-sm-4 mt-md-0" *ngIf="currentInvoiceType == 4 && (vistaResumen === 'CLP' || opciones.tipoMoneda === 'CLP')">
		<div class="card card-custom">
			<div class="card-content">
				<div class="card-header d-flex justify-content-between align-items-center">
					<h5 class="mb-0">Resumen</h5>
					<div class="toggle-switch toggle-switch--sm" *ngIf="opciones.tipoMoneda != 'CLP'">
						<button type="button" class="toggle-btn" [class.active]="vistaResumen === 'CLP'" (click)="seleccionarVistaResumen('CLP')">CLP</button>
						<button type="button" class="toggle-btn" [class.active]="vistaResumen === 'EXTRANJERA'" (click)="seleccionarVistaResumen('EXTRANJERA')">{{ opciones.tipoMoneda === "OTHER" ? "Otra Moneda" : opciones.tipoMoneda }}</button>
					</div>
				</div>
				<div class="card-body">
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Valor de Bienes</div>
						<div class="col-7 text-right">
							{{ exentoResumen | number : "1.0-2" : "es" }}
						</div>
					</div>
					<!-- <div class="form-group row mx-auto">
                        <div class="col-5 label-control">
                            Total
                        </div>
                        <div class="col-7 text-right">
                           {{totalResumen | number:'1.0-0':'es'}}
                        </div>
                    </div> -->
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Flete</div>
						<div class="col-7 text-right">
							{{ fleteResumen | number : "1.0-2" : "es" }}
						</div>
					</div>
					<div class="form-group row mx-auto">
						<div class="col-5 label-control">Seguro</div>
						<div class="col-7 text-right">
							{{ seguroResumen | number : "1.0-2" : "es" }}
						</div>
					</div>
					<div class="form-group row mx-auto" *ngIf="currentInvoiceType == 4">
						<div class="col-5 label-control">Clausula de Venta</div>
						<div class="col-7 text-right">
							{{ totalClausulaVenta | number : "1.0-2" : "es" }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- RESUMEN EN MONEDA EXTRANJERA PARA DTE EN GENERAL -->
	<div class="col-xl-4 col-md-6 col-xs-12 mt-sm-4 mt-md-0" *ngIf="currentInvoiceType != 4 && opciones.tipoMoneda != 'CLP' && vistaResumen === 'EXTRANJERA'">
		<div class="card card-custom">
			<div class="card-content">
				<div class="card-header d-flex justify-content-between align-items-center">
					<h5 class="mb-0">Resumen {{ opciones.tipoMoneda === "OTHER" ? "Otra Moneda" : opciones.tipoMoneda }}</h5>
					<div class="toggle-switch toggle-switch--sm">
						<button type="button" class="toggle-btn" [class.active]="false" (click)="seleccionarVistaResumen('CLP')">CLP</button>
						<button type="button" class="toggle-btn" [class.active]="vistaResumen === 'EXTRANJERA'" (click)="seleccionarVistaResumen('EXTRANJERA')">{{ opciones.tipoMoneda === "OTHER" ? "Otra Moneda" : opciones.tipoMoneda }}</button>
					</div>
				</div>
				<div class="card-body">
					<div class="alter-resumen" *ngIf="opciones.tipoMoneda != 'CLP'">
						<div class="form-group row mx-auto">
							<div class="col-5 label-control">
								Neto
								{{
									opciones.tipoMoneda != "CLP"
										? opciones.tipoMoneda == "OTHER"
											? "Otra
                                Moneda"
											: opciones.tipoMoneda
										: ""
								}}
							</div>
							<div class="col-7 text-right">
								{{ this.otraMonedaResumen.montoNeto | number : "1.0-0" : "es" }}
							</div>
						</div>
						<div class="form-group row mx-auto">
							<div class="col-5 label-control">
								Subtotal
								{{
									opciones.tipoMoneda != "CLP"
										? opciones.tipoMoneda == "OTHER"
											? "Otra
                                Moneda"
											: opciones.tipoMoneda
										: ""
								}}
							</div>
							<div class="col-7 text-right">
								{{ this.subTotalForeign | number : "1.0-0" : "es" }}
							</div>
						</div>
						<div class="form-group row mx-auto">
							<div class="col-5 label-control">
								Exento
								{{
									opciones.tipoMoneda != "CLP"
										? opciones.tipoMoneda == "OTHER"
											? "Otra
                                Moneda"
											: opciones.tipoMoneda
										: ""
								}}
							</div>
							<div class="col-7 text-right">
								{{ this.otraMonedaResumen.montoExento | number : "1.0-0" : "es" }}
							</div>
						</div>
						<div class="form-group row mx-auto">
							<div class="col-5 label-control">
								IVA
								{{
									opciones.tipoMoneda != "CLP"
										? opciones.tipoMoneda == "OTHER"
											? "Otra
                                Moneda"
											: opciones.tipoMoneda
										: ""
								}}
							</div>
							<div class="col-7 text-right">
								{{ this.otraMonedaResumen.iva | number : "1.0-0" : "es" }}
							</div>
						</div>
						<div class="form-group row mx-auto">
							<div class="col-5 label-control">
								Imp. Específico
								{{
									opciones.tipoMoneda != "CLP"
										? opciones.tipoMoneda == "OTHER"
											? "Otra
                                Moneda"
											: opciones.tipoMoneda
										: ""
								}}
							</div>
							<div class="col-7 text-right">
								{{ this.otraMonedaResumen.imptoEspecifico | number : "1.0-0" : "es" }}
							</div>
						</div>

						<div class="form-group row mx-auto">
							<div class="col-5 label-control">
								Total
								{{
									opciones.tipoMoneda != "CLP"
										? opciones.tipoMoneda == "OTHER"
											? "Otra
                                Moneda"
											: opciones.tipoMoneda
										: ""
								}}
							</div>
							<div class="col-7 text-right">
								{{ this.otraMonedaResumen.montoTotal | number : "1.0-0" : "es" }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- RESUMEN EN MONEDA EXTRANJERA PARA DTE EXPORTACION -->
	<div class="col-xl-4 col-md-6 col-xs-12 mt-sm-4 mt-md-0" *ngIf="currentInvoiceType == 4 && opciones.tipoMoneda != 'CLP' && vistaResumen === 'EXTRANJERA'">
		<div class="card card-custom">
			<div class="card-content">
				<div class="card-header d-flex justify-content-between align-items-center">
					<h5 class="mb-0">Resumen {{ opciones.tipoMoneda === "OTHER" ? "Otra Moneda" : opciones.tipoMoneda }}</h5>
					<div class="toggle-switch toggle-switch--sm">
						<button type="button" class="toggle-btn" [class.active]="false" (click)="seleccionarVistaResumen('CLP')">CLP</button>
						<button type="button" class="toggle-btn" [class.active]="vistaResumen === 'EXTRANJERA'" (click)="seleccionarVistaResumen('EXTRANJERA')">{{ opciones.tipoMoneda === "OTHER" ? "Otra Moneda" : opciones.tipoMoneda }}</button>
					</div>
				</div>
				<div class="card-body">
					<div class="alter-resumen" *ngIf="opciones.tipoMoneda != 'CLP'">
						<div class="form-group row mx-auto">
							<div class="col-5 label-control">
								Valor de Bienes
								{{
									opciones.tipoMoneda != "CLP"
										? opciones.tipoMoneda == "OTHER"
											? "Otra
                                Moneda"
											: opciones.tipoMoneda
										: ""
								}}
							</div>
							<div class="col-7 text-right">
								{{ this.otraMonedaResumen.montoExento | number : "1.0-0" : "es" }}
							</div>
						</div>
						<div class="form-group row mx-auto">
							<div class="col-5 label-control">
								Flete
								{{
									opciones.tipoMoneda != "CLP"
										? opciones.tipoMoneda == "OTHER"
											? "Otra
                                Moneda"
											: opciones.tipoMoneda
										: ""
								}}
							</div>
							<div class="col-7 text-right">
								{{ this.otraMonedaResumen.flete | number : "1.0-0" : "es" }}
							</div>
						</div>
						<div class="form-group row mx-auto" *ngIf="opciones.tipoMoneda != 'CLP'">
							<div class="col-5 label-control">
								Seguro
								{{
									opciones.tipoMoneda != "CLP"
										? opciones.tipoMoneda == "OTHER"
											? "Otra
                                Moneda"
											: opciones.tipoMoneda
										: ""
								}}
							</div>
							<div class="col-7 text-right">
								{{ this.otraMonedaResumen.seguro | number : "1.0-0" : "es" }}
							</div>
						</div>
						<div class="form-group row mx-auto">
							<div class="col-5 label-control">Clausula de Venta</div>
							<div class="col-7 text-right">
								{{ this.otraMonedaResumen.montoClausulaVenta | number : "1.0-0" : "es" }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</div>
<swal #currentSwal title="Operación" text="Operación realizada" icon="info" style="z-index: 900000 !important"></swal>

<ng-template #credECTemplate>
	<div class="opcion-adicional-card" [formGroup]="totalesDteFormGroup">
		<div class="opcion-adicional-card__header">
			<div class="opcion-adicional-card__title">Crédito especial empresas constructoras (65% del IVA)</div>
			<div class="toggle-switch">
				<button type="button" class="toggle-btn" [class.active]="!totalesDteFormGroup.controls.aplicaCredEC.value" (click)="onChangeCredECValue(false)">No</button>
				<button type="button" class="toggle-btn" [class.active]="totalesDteFormGroup.controls.aplicaCredEC.value" (click)="onChangeCredECValue(true)">Sí</button>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #ivaTercerosTemplate>
	<div class="opcion-adicional-card" [formGroup]="totalesDteFormGroup">
		<div class="opcion-adicional-card__header">
			<div class="opcion-adicional-card__title">IVA Terceros</div>
				<div class="toggle-switch">
					<button type="button" class="toggle-btn" [class.active]="!showInputIvaTerceros" (click)="changeHaveIvaTercerosValue(false)">No</button>
					<button type="button" class="toggle-btn" [class.active]="showInputIvaTerceros" (click)="changeHaveIvaTercerosValue(true)">Sí</button>
				</div>
		</div>
		<div class="opcion-adicional-card__values" *ngIf="showInputIvaTerceros">
			<div class="opcion-adicional-card__field">
				<label class="opcion-adicional-card__label">IVA de terceros</label>
				<input currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',', precision: '0' }" class="form-control" formControlName="ivaTerceros" (blur)="calculateIvaPropio()" />
				<div *ngIf="totalesDteFormGroup.touched && totalesDteFormGroup.controls.ivaTerceros.invalid" class="text-danger">
					<div *ngIf="totalesDteFormGroup.controls.ivaTerceros.errors?.PositiveNumber">Número debe ser positivo</div>
				</div>
			</div>
			<div class="opcion-adicional-card__field">
				<label class="opcion-adicional-card__label">IVA propio</label>
				<input type="number" class="form-control" formControlName="ivaPropio" disabled />
				<div *ngIf="totalesDteFormGroup.touched && totalesDteFormGroup.controls.ivaPropio.invalid" class="text-danger">
					<div *ngIf="totalesDteFormGroup.controls.ivaPropio.errors?.PositiveNumber">Número debe ser positivo</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>
